<script setup lang="ts">
defineProps<{
  opensOnMap?: boolean;
}>();
</script>

<template>
  <article class="@container/tile flex flex-row in-[.group\/popup]:flex-col justify-between gap-4">
    <div class="grow min-w-0">
      <div class="space-y-3.5 mb-5.5">
        <USkeleton class="h-6 @xs/tile:h-7 w-3/4" />
        <USkeleton class="h-4.5 w-1/2" />
      </div>
      <ul class="space-y-2 mb-5.5">
        <li><USkeleton class="h-5 w-40" /></li>
      </ul>
      <USkeleton class="h-6 w-15 rounded" />
    </div>

    <USkeleton v-if="opensOnMap" class="size-10 rounded shrink-0" />
  </article>
</template>
